/** Товар у каталозі для фіду / лічильників: явні прапорці після міграції. */
const isCatalogFeedProduct = (product) =>
  product.isActive === true && product.isArchived === false

export default isCatalogFeedProduct
